module.exports = __webpack_public_path__ + "img/tx.7e2ca581.png";